import React, { useEffect, useState } from 'react'
import { firestore } from '../../../../../firebase';
import PlayerSavedTeam from './PlayerSavedTeam';
import { MDBDataTable, MDBRow, MDBCol } from 'mdbreact';
import { generateTeamName } from '../../../../../helpers/teamNameFormatter';
import AddManualTeamPlayer from './AddManualTeamPlayer';

function TeamDrawPlayers({draw, type, drawId, drawNumber, hostcupId, roundId, roundData, registeredPlayers}) {

    const [numberOfTeams, setNumberOfTeams] = useState(8)
    const [playersTeam, setPlayersTeam] = useState(5)
    const [round, setRound] = useState()
    const [sortCount, setSortCount] = useState(0)

    const [newDraw, setNewDraw] = useState(draw)


    const [show, setShow] = useState(false)
    const [searchTerm, setSearchTerm] = useState("");
    const [playersFiltered, setPlayersFiltered] = useState(registeredPlayers)
    const [playerSelected, setPlayerSelected] = useState()
    const [playersAdded, setPlayersAdded] = useState([newDraw])

    useEffect(() => {

        try {
            const roundRef = firestore.collection("hostcup").doc(hostcupId).collection("rounds").doc(roundId);
            roundRef.onSnapshot(doc => {
                const round = {id: doc.id, ...doc.data()}
                setRound(round);
                setNumberOfTeams(round.num_teams)
                setPlayersTeam(round.players_per_team)
            });
        } catch (error) {
            
        }

    }, [hostcupId, roundId])

    useEffect(() => {

        try {
            const playersRef = firestore.collection("hostcup").doc(hostcupId).collection("rounds").doc(roundId).collection("players");
            playersRef.onSnapshot(({docs}) => {
                const players = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                });
                setPlayersFiltered(players);
            })
        } catch (error) {
            console.log("error", error)
        }

    }, [hostcupId, roundId])




    useEffect(() => {
        //console.log(roundData, "ROUND DATA")
    }, [])

    async function saveDraw(e, teamId) {
        console.log(teamId, hostcupId, roundId)
        e.preventDefault();
        try {
            const teamRef = firestore.collection("hostcup").doc(hostcupId).collection("rounds").doc(roundId).collection("teams").doc(teamId);
            const data = {
                teams: newDraw,
                draw: drawNumber
            }
            console.log(data)
            teamRef.update(data);
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        const teamName = generateTeamName(1,numberOfTeams, playersTeam, newDraw.length)
        console.log(numberOfTeams, playersTeam, newDraw.length)
        console.log(teamName, "Team Name")

        const sortedArray = newDraw.sort((a, b) => (a.team_name > b.team_name) ? 1 : -1)
        setNewDraw(sortedArray)
    }, [sortCount])

    function sortArray(array) {
        const sortedArray = array.sort((a, b) => (a.team_name > b.team_name) ? 1 : -1)
        setNewDraw(sortedArray)

        setSortCount(sortCount+1)
        return sortedArray
    }

    const tableRows2 = newDraw.map(player => {
        return (
            {
                index: player.index,
                team: player.team_name,
                name: player.player_name,
                players_team: player.index
            }
        )
    
    })
    
       
    
    const data = () => ({
        columns: [
            {
                label: 'Team',
                field: 'team',
                width: 270
            },
            {
                label: 'Spiller',
                field: 'name',
                width: 400
            },
            {
                label: 'Antall',
                field: 'players_team',
                width: 400
            }
        ],
        rows: tableRows2
    });

    useEffect(() => {

        if (searchTerm) {
            console.log(registeredPlayers)
            const filteredArray = registeredPlayers.filter(player => {
                return player.player_name.toLowerCase().includes(searchTerm.toLowerCase())
            })
            setPlayersFiltered(filteredArray)
        }

    }, [searchTerm])

    function toggle() {
        if (show) {
            setShow(false)
        } else {
            setShow(true)
        }
    }

    return (
        <React.Fragment>
            <h4>Team Draw Players</h4>
            
            {!draw && <div className="alert alert-danger">Fant ikke spillertabell</div>}
            {roundData && draw && <p>Trekning {drawNumber}: {draw.length} spillere fordelt på {roundData.num_teams} lag</p>}
            
            <hr />
            
            <div className="row my-3">
                <div className="col-6">
                    <button className="btn btn-sm btn-block btn-success" onClick={toggle}>Legg til spiller</button>
                </div>
                <div className="col-6">
                    <button className="btn btn-sm btn-block btn-info" onClick={() => sortArray(newDraw)}>Sorter lag</button>
                </div>
                
            </div>

            {show && (
                <React.Fragment>
                    <input className="form-control mb-2" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} placeholder="Søk spiller" />
                    <label>Spiller</label>
                    {playersFiltered.map((player, index) => {
                        return (
                            <AddManualTeamPlayer 
                                key={index} 
                                player={player}
                                playerSelected={playerSelected}
                                setPlayerSelected={setPlayerSelected}
                                playersAdded={newDraw}
                                setPlayersAdded={setNewDraw}
                            />
                        )
                    })}
                </React.Fragment>
            )}


            {newDraw?.map((player, index) => {
                return (
                    <PlayerSavedTeam 
                        key={index} 
                        index={index}
                        player={player}
                        numberOfTeams={numberOfTeams} 
                        playersTeam={playersTeam} 
                        draw={newDraw} 
                        type={type} 
                        setNewDraw={setNewDraw}
                        sortCount={sortCount}
                        setSortCount={setSortCount}
                    />
                )
            })}

            <button onClick={(e) => saveDraw(e, drawId)} className="btn btn-success btn-block">Lagre endringer</button>
            <MDBRow className='py-3'>
                <MDBCol md='12'>
                    <div className="table-responsive">
                        <MDBDataTable small striped bordered hover searching={true} data={data()} />
                    </div>
                </MDBCol>
            </MDBRow>
        </React.Fragment>
    )

}
export default TeamDrawPlayers